import { Controller } from "stimulus"
export default class extends Controller {
    static targets = [ "app_info_agreed", "recommendation_agreed", "promotion_agreed" ]
    receive_email_preferences_toggle(event) {
        let formData = new FormData()
        formData.append("profile[app_info_agreed]", this.app_info_agreedTarget.checked ? "true" : "false");
        formData.append("profile[recommendation_agreed]", this.recommendation_agreedTarget.checked ? "true" : "false");
        formData.append("profile[promotion_agreed]", this.promotion_agreedTarget.checked ? "true" : "false");

        fetch(this.data.get("update-url"), {
            body: formData,
            method: 'PATCH',
            credentials: "include",
            dataType: "script",
            headers: {
                    "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content 
             },
        })

    }
}
